import React from 'react';

class fourButton extends React.Component {
  render() {
    return (
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_241_844)">
          <path
            d="M57.81 6H22.19C13.2485 6 6 13.2485 6 22.19V57.81C6 66.7515 13.2485 74 22.19 74H57.81C66.7515 74 74 66.7515 74 57.81V22.19C74 13.2485 66.7515 6 57.81 6Z"
            fill="#E0DDDA"
          />
          <path
            d="M57.8102 74.8H22.1902C12.8222 74.8 5.2002 67.178 5.2002 57.81V22.19C5.2002 12.822 12.8222 5.19995 22.1902 5.19995H57.8102C67.1782 5.19995 74.8002 12.822 74.8002 22.19V57.81C74.8002 67.178 67.1782 74.8 57.8102 74.8ZM22.1902 6.79995C13.7042 6.79995 6.8002 13.704 6.8002 22.19V57.81C6.8002 66.296 13.7042 73.2 22.1902 73.2H57.8102C66.2962 73.2 73.2002 66.296 73.2002 57.81V22.19C73.2002 13.704 66.2962 6.79995 57.8102 6.79995H22.1902Z"
            fill="#84827E"
          />
          <path
            d="M56.1924 10.8579H23.8104C16.6572 10.8579 10.8584 16.6567 10.8584 23.8099V56.1919C10.8584 63.3451 16.6572 69.1439 23.8104 69.1439H56.1924C63.3456 69.1439 69.1444 63.3451 69.1444 56.1919V23.8099C69.1444 16.6567 63.3456 10.8579 56.1924 10.8579Z"
            fill="white"
          />
          <path
            d="M56.1906 69.9419H23.8106C16.2266 69.9419 10.0586 63.7719 10.0586 56.1899V23.8099C10.0586 16.2259 16.2286 10.0579 23.8106 10.0579H56.1906C63.7746 10.0579 69.9426 16.2279 69.9426 23.8099V56.1899C69.9426 63.7739 63.7726 69.9419 56.1906 69.9419ZM23.8106 11.6579C17.1106 11.6579 11.6586 17.1099 11.6586 23.8099V56.1899C11.6586 62.8899 17.1106 68.3419 23.8106 68.3419H56.1906C62.8906 68.3419 68.3426 62.8899 68.3426 56.1899V23.8099C68.3426 17.1099 62.8906 11.6579 56.1906 11.6579H23.8106Z"
            fill="#84827E"
          />
          <path
            d="M32.7722 47.3818H24.6802C24.2322 47.3818 23.8682 47.7458 23.8682 48.1938V56.2818C23.8682 56.7318 24.2322 57.0958 24.6802 57.0958H32.7722C33.2202 57.0958 33.5842 56.7318 33.5842 56.2818V48.1938C33.5842 47.7458 33.2202 47.3818 32.7722 47.3818V47.3818Z"
            fill="url(#paint0_linear_241_844)"
          />
          <path
            d="M28.7262 32.6179C31.4092 32.6179 33.5842 30.4429 33.5842 27.7599C33.5842 25.0769 31.4092 22.9019 28.7262 22.9019C26.0432 22.9019 23.8682 25.0769 23.8682 27.7599C23.8682 30.4429 26.0432 32.6179 28.7262 32.6179Z"
            fill="url(#paint1_linear_241_844)"
          />
          <path
            d="M47.1386 32.1319H55.4066C55.6626 32.1319 55.9066 31.9919 56.0326 31.7639C56.1626 31.5379 56.1626 31.2579 56.0326 31.0299L51.9006 23.7559C51.7706 23.5279 51.5306 23.3879 51.2726 23.3879C51.0146 23.3879 50.7786 23.5239 50.6486 23.7499L46.5106 31.0279C46.3806 31.2539 46.3806 31.5379 46.5106 31.7619C46.6406 31.9899 46.8806 32.1299 47.1366 32.1299L47.1386 32.1319Z"
            fill="url(#paint2_linear_241_844)"
          />
          <path
            d="M53.1205 52.2401L56.0025 49.3581C56.1725 49.1881 56.1725 48.9121 56.0025 48.7421L54.7705 47.5101C54.6005 47.3401 54.3245 47.3401 54.1545 47.5101L51.2725 50.3921L48.3905 47.5101C48.2205 47.3401 47.9445 47.3401 47.7745 47.5101L46.5425 48.7421C46.3725 48.9121 46.3725 49.1881 46.5425 49.3581L49.4245 52.2401L46.5425 55.1221C46.3725 55.2921 46.3725 55.5681 46.5425 55.7381L47.7745 56.9701C47.9445 57.1401 48.2205 57.1401 48.3905 56.9701L51.2725 54.0881L54.1545 56.9701C54.3245 57.1401 54.6005 57.1401 54.7705 56.9701L56.0025 55.7381C56.1725 55.5681 56.1725 55.2921 56.0025 55.1221L53.1205 52.2401Z"
            fill="url(#paint3_linear_241_844)"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_241_844"
            x="3.8002"
            y="3.79995"
            width="75.5996"
            height="75.6001"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="1.6" dy="1.6" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_241_844"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_241_844"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_241_844"
            x1="25.2347"
            y1="48.2507"
            x2="31.8285"
            y2="55.8156"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_241_844"
            x1="25.2347"
            y1="23.7709"
            x2="31.83"
            y2="31.336"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_241_844"
            x1="47.7798"
            y1="24.17"
            x2="53.599"
            y2="31.5877"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_241_844"
            x1="47.7815"
            y1="48.2515"
            x2="54.3761"
            y2="55.8159"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
}
export default fourButton;
